import { makeStyles } from '@material-ui/core'
import { deepPurple } from '@material-ui/core/colors'

export default makeStyles((theme) => ({
  appBar: {
    padding: theme.spacing(3, 1, 3, 1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '70px',
    backgroundColor: '#fff',
    boxShadow: `0 0.3px 6px 0 rgb(0 0 0 / 0.2)`,
    [theme.breakpoints.down('xs')]: {
      height: '50px',
    },
  },

  image: {
    margin: '2px 20px 2px 20px',
    height: 40,
    [theme.breakpoints.down('xs')]: {
      margin: '2px 20px 2px auto',
      height: 20,
    },
  },
  [theme.breakpoints.down('sm')]: {
    mainContainer: {
      flexDirection: 'column-reverse',
    },
  },

  grow: {
    flexGrow: 1,
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
    marginRight: '15px',
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  brandContainer: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '15px',
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
    height: '40px',
    width: '40px',
    marginLeft: '15px',
    marginRight: 0,
  },
  leftSideHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  profile: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  loginButton: {
    backgroundColor: '#000',
    borderRadius: '5px',
    margin: '7px 7px 0 0',
    width: '100px',
    height: '70%',
    color: 'white',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
  },
  logoutButton: {
    margin: '7px 7px 0 0',
    borderRadius: '5px',
    width: '100px',
    height: '70%',
    color: 'white',
    '&:hover': {
      background:
        'linear-gradient(90deg, #1e0024 0%, #090f79 59%, #00ecff 100%)',
    },
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
}))
